function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import { getId } from '@fluentui/utilities';
import { SignInModal } from '@shared/containers/modals/signInModalContainer';
import MediaModal from './mediaModal';
import VideoModal from './videoModal';
import DriveModal from './driveModal';
import { FieldHubModal } from '@shared/containers/modals/fieldHubModal';
import ErrorModal from '@shared/containers/modals/errorModal';
import AnimationModal from './animationModal';
import DisclaimerModal from './disclaimerModal';
import NpsModal from './npsModal';
import { InstructionsModal } from './instructionsModal';
import { DownloadSampleModal } from './downloadSampleModal';
import SpzaComponent from './../spzaComponent';
import { Constants } from '@shared/utils/constants';
import { urlReplace, routes, appendQueryParams } from '@shared/routerHistory';
import { getWindow } from '@shared/services/window';
import { removeURLParameter } from '@shared/utils/appUtils';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { NpsModule } from '@shared/utils/npsUtils';
import { handleConsentModalCall } from '@shared/handlers/consentModalHandler';
import { handleRatingModal } from 'handlers/ratingModalHandler';
import { handleReportAbuseModalCall } from '@shared/handlers/reportAbuseModalHandler';
import { stringifyError } from '@shared/utils/errorUtils';
import { FocusTrapZone } from '@fluentui/react';
import { ReviewCommentModal } from '@shared/containers/modals/reviewCommentModal';
import { logger } from '@src/logger';
import { ReviewMarkAsHelpfulModal } from '@shared/components/modals/reviewMarkAsHelpfulModal';
import classNames from 'classnames';
export class Modal extends SpzaComponent {
    componentDidMount() {
        this.attachElementToDOM();
        const perfPayload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End,
            details: JSON.stringify({
                ModalId: this.props.modalId
            })
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', perfPayload);
        logger.info(perfPayload.details, {
            action: perfPayload.action,
            actionModifier: perfPayload.actionModifier
        });
        getWindow().addEventListener('keydown', this.handleKeyPress.bind(this), false);
        NpsModule.BlockShowingNPS();
    }
    handleKeyPress(e) {
        const { disableDismissModal } = this.props;
        if (e.code === 'Escape' && !disableDismissModal) {
            this.dismissModal();
        }
    }
    componentWillUnmount() {
        const currWindow = getWindow();
        currWindow.removeEventListener('keydown', this.handleKeyPress.bind(this), false);
        // During CTA experience, when the user gets back from the Sign-in/Sign-up page to the modal,
        // there will be a query parameter(modalAppId) added in the end.
        // So, when the modal is dismissed, we need to get rid of this parameter
        if (currWindow.location.href.indexOf('modalAppId') > -1) {
            const pageURL = removeURLParameter(currWindow.location.href, 'modalAppId');
            urlReplace(pageURL);
        }
        NpsModule.AllowShowingNPS();
        if (this.trigger) {
            this.trigger.focus();
        }
        this.removeElementFromDOM();
    }
    dismissModal() {
        const { disableDismissModal } = this.props;
        if (disableDismissModal) {
            return;
        }
        if (this.props.modalId === Constants.ModalType.Error) {
            if (!this.props.isEmbedded) {
                this.props.dismissModalWithRedirect(this.context.buildHref(routes.home, null, {
                    category: null,
                    industry: null,
                    product: null,
                    search: null
                }));
            } else {
                let href = this.context.buildHref(routes.marketplace, null, {
                    category: null,
                    industry: null,
                    product: null,
                    showPrivateApps: false,
                    search: null,
                    page: null
                });
                // For the embedded app we need to convert the relative path to an absolute path by adding '/embed'
                href = '/embed' + appendQueryParams(href, {
                    embedHost: this.props.embedHost
                });
                this.props.dismissModalWithRedirect(href);
            }
        } else {
            this.props.dismissModal();
        }
        if (this.props.onModalDismiss) {
            this.props.onModalDismiss();
        }
    }
    renderImpl() {
        const { disableDismissModal } = this.props;
        let modalContent = null;
        let dismissModal = this.dismissModal.bind(this);
        let modalBackgroundClasses = classNames({
            spza_presentation: true,
            spza_background_1: true,
            spza_background_2: false
        });
        let modalClasses = classNames({
            spza_dialog: true,
            spza_dialog_design2: false
        });
        let appData = null;
        let service = null;
        switch(this.props.modalId){
            case Constants.ModalType.SignIn:
                modalContent = /*#__PURE__*/ _jsx(SignInModal, {
                    dismissModal: dismissModal,
                    altAuth: this.props.featureFlags.AltAuth,
                    signInModalType: Constants.SignInType.SignInWith_MSA_AAD,
                    disableDismissModal: disableDismissModal
                });
                break;
            case Constants.ModalType.CTA:
                if (this.props.entityType === Constants.EntityType.App) {
                    try {
                        appData = [
                            ...this.props.allApps,
                            ...this.props.allCloudsIndustry
                        ].find((x)=>x.entityId === this.props.entityId);
                        // check the public offers first and then the private
                        if (!appData) {
                            appData = this.props.allPrivateOffers.find((app)=>app.entityId === this.props.entityId);
                            if (!appData) {
                                var _this_props_allFavouriteApps_find;
                                appData = (_this_props_allFavouriteApps_find = this.props.allFavouriteApps.find((app)=>app.item.entityId === this.props.entityId)) === null || _this_props_allFavouriteApps_find === void 0 ? void 0 : _this_props_allFavouriteApps_find.item;
                            }
                            if (appData) {
                                this.props.updateAppEntity(appData);
                            }
                        }
                        if (!appData) {
                            this.getAppDetails();
                        }
                    } catch (error) {
                        const payload = {
                            page: getWindow().location.href,
                            action: Constants.Telemetry.Action.PageLoad,
                            actionModifier: Constants.Telemetry.ActionModifier.Error,
                            details: `Case Constants.ModalType.CTA - this.props.allApps= ${JSON.stringify(this.props.allApps)}, error msg= ${stringifyError(error)}`
                        };
                        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
                        logger.error(payload.details, {
                            action: payload.action,
                            actionModifier: payload.actionModifier
                        });
                        throw error;
                    }
                } else if (this.props.entityType === Constants.EntityType.Service) {
                    service = [
                        ...this.props.allServices,
                        ...this.props.allCloudsIndustry
                    ].filter((x)=>{
                        return x && x.entityId === this.props.entityId;
                    })[0];
                }
                if ((appData === null || appData === void 0 ? void 0 : appData.CertificationState) === Constants.CertificationType.MicrosoftCertified) {
                    const payloadInfo = {
                        page: getWindow().location.href,
                        action: Constants.Telemetry.Action.Click,
                        actionModifier: Constants.Telemetry.ActionModifier.Info,
                        details: JSON.stringify({
                            contentName: 'M365 Certified'
                        })
                    };
                    SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payloadInfo);
                    logger.info(payloadInfo.details, {
                        action: payloadInfo.action,
                        actionModifier: payloadInfo.actionModifier
                    });
                }
                modalContent = handleConsentModalCall(this.props, appData, dismissModal, service);
                break;
            case Constants.ModalType.Video:
                modalContent = /*#__PURE__*/ _jsx(VideoModal, {
                    video: this.props.payload,
                    dismissModal: dismissModal
                });
                break;
            case Constants.ModalType.MediaModal:
                modalContent = /*#__PURE__*/ _jsx(MediaModal, {
                    payload: this.props.payload,
                    dismissModal: dismissModal
                });
                break;
            case Constants.ModalType.Drive:
                modalContent = /*#__PURE__*/ _jsx(DriveModal, {
                    drive: this.props.payload,
                    dismissModal: dismissModal
                });
                break;
            case Constants.ModalType.Iframe:
                modalBackgroundClasses = classNames({
                    spza_presentation: true,
                    spza_background_1: false,
                    spza_background_2: true
                });
                modalContent = /*#__PURE__*/ _jsx(FieldHubModal, {
                    iframeProps: this.props.payload,
                    dismissModal: dismissModal
                });
                dismissModal = null;
                break;
            case Constants.ModalType.Error:
                modalContent = /*#__PURE__*/ _jsx(ErrorModal, {
                    dismissModal: dismissModal
                });
                break;
            case Constants.ModalType.Disclaimer:
                modalBackgroundClasses = classNames({
                    spza_presentation: true,
                    spza_background_1: false,
                    spza_background_2: true
                });
                modalClasses = classNames({
                    spza_dialog: true,
                    spza_dialog_design2: true
                });
                modalContent = /*#__PURE__*/ _jsx(DisclaimerModal, {
                    payload: this.props.payload,
                    dismissModal: dismissModal
                });
                dismissModal = null;
                break;
            case Constants.ModalType.NPS:
                modalContent = /*#__PURE__*/ _jsx(NpsModal, {
                    dismissModal: dismissModal,
                    emailAddress: this.props.userInfo.signedIn ? this.props.userInfo.email : 'no user'
                });
                dismissModal = null;
                break;
            case Constants.ModalType.Rating:
                try {
                    appData = this.props.allApps.filter((x)=>{
                        return x.entityId.toLowerCase() === this.props.payload.app.entityId.toLowerCase();
                    })[0];
                } catch (error) {
                    const payload = {
                        page: getWindow().location.href,
                        action: Constants.Telemetry.Action.PageLoad,
                        actionModifier: Constants.Telemetry.ActionModifier.Error,
                        details: `Case Constants.ModalType.Rating - this.props.allApps= ${JSON.stringify(this.props.allApps)}, error msg= ${stringifyError(error)}`
                    };
                    SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
                    logger.error(payload.details, {
                        action: payload.action,
                        actionModifier: payload.actionModifier
                    });
                    throw error;
                }
                modalContent = handleRatingModal(this.props, appData, dismissModal, service);
                dismissModal = null;
                break;
            case Constants.ModalType.ReviewComment:
                modalContent = /*#__PURE__*/ _jsx(ReviewCommentModal, {
                    payload: this.props.payload,
                    dismissModal: dismissModal
                });
                dismissModal = null;
                break;
            case Constants.ModalType.ReviewMarkAsHelpful:
                modalContent = /*#__PURE__*/ _jsx(ReviewMarkAsHelpfulModal, {
                    payload: this.props.payload,
                    dismissModal: dismissModal
                });
                dismissModal = null;
                break;
            case Constants.ModalType.Animation:
                modalContent = /*#__PURE__*/ _jsx(AnimationModal, {});
                break;
            case Constants.ModalType.ReportAbuse:
                var _this_props_options, _this_props_options1, _this_props_options2, _this_props_options3;
                modalContent = handleReportAbuseModalCall((_this_props_options = this.props.options) === null || _this_props_options === void 0 ? void 0 : _this_props_options.appId, (_this_props_options1 = this.props.options) === null || _this_props_options1 === void 0 ? void 0 : _this_props_options1.reviewId, (_this_props_options2 = this.props.options) === null || _this_props_options2 === void 0 ? void 0 : _this_props_options2.reviewTitle, this.props.userInfo, (_this_props_options3 = this.props.options) === null || _this_props_options3 === void 0 ? void 0 : _this_props_options3.reviewSource, dismissModal);
                break;
            case Constants.ModalType.Instructions:
                modalContent = /*#__PURE__*/ _jsx(InstructionsModal, {
                    context: this.context,
                    isFromDownload: this.props.payload.isFromDownload,
                    dismissModal: dismissModal
                });
                break;
            case Constants.ModalType.DownloadSample:
                modalContent = /*#__PURE__*/ _jsx(DownloadSampleModal, {
                    context: this.context,
                    dismissModal: dismissModal
                });
                break;
            default:
                break;
        }
        return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx(FocusTrapZone, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: modalClasses,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: modalBackgroundClasses,
                        onClick: dismissModal
                    }),
                    modalContent
                ]
            })
        }), this.domTreeElement);
    }
    constructor(props, context){
        var _this;
        super(props, context), _this = this, _define_property(this, "context", void 0), _define_property(this, "trigger", null), _define_property(this, "domTreeElement", void 0), _define_property(this, "attachElementToDOM", ()=>document.body.appendChild(this.domTreeElement)), _define_property(this, "removeElementFromDOM", ()=>document.body.removeChild(this.domTreeElement)), _define_property(this, "getAppDetails", /*#__PURE__*/ _async_to_generator(function*() {
            const { entityId, fetchAppDetails } = _this.props;
            fetchAppDetails(entityId);
        }));
        this.domTreeElement = document.createElement('div');
        this.domTreeElement.setAttribute('id', getId('modal'));
        this.trigger = document.activeElement;
    }
}
Modal.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
